export default __webpack_public_path__ + "static/needlefilewithorangewax-8a493a68c27ec7bd385281fe6228f3f2.png";